import * as React from 'react';
import { isMobile } from 'react-device-detect';

import { ReactComponent as Bullet } from 'src/images/bullet-checkmark.svg';

import { useCustomText } from 'src/hooks/useCustomText';

import {
  useContractContext,
  usePostMessageContext,
} from 'src/providers';

import { ContractDetailsRequestedPromptOptions } from 'src/types/IModal';

import { StyledValuePropPrompt } from './StyledValueProp';
import { Header, HeaderPromptTypes } from 'src/components/Prompts/Header';
import { CollapsableList } from './CollapsableList';

interface IValuePropPromptProps {
  contractDetailsRequested: (prompt: ContractDetailsRequestedPromptOptions) => void;
  isList?: boolean;
}

export function ValueProp(props: IValuePropPromptProps) {

  const [open, setOpen] = React.useState(false);
  const { contractDetailsRequested } = props;
  const { contracts, selectedContractId, toggleContract } = useContractContext();
  const { postMessage } = usePostMessageContext();
  const valueBullets = [
    'Peace of mind with every purchase',
    'Forget about surprise expenses',
    'Fast and easy repair or replacement',
  ];

  const customHeadertLabel = useCustomText(
    'pagePromptHeadline',
    'Add product protection:',
  );

  const renderBullet = (bullet: string, index: number) => {
    return (
      <li key={index} className="bullet">
        <Bullet className="checkmark" />
        <span className="text">{bullet}</span>
      </li>
    );
  };

  const handleInfoIconClick = React.useCallback(() => {
    contractDetailsRequested(ContractDetailsRequestedPromptOptions.VALUEPROP);
    postMessage('learnMoreOpenModal', { 
      buttonText: 'info icon',
      cta: 'PDP',
      prompt: 'valueprop'});
  }, [contractDetailsRequested, postMessage]);

  return (
    <StyledValuePropPrompt data-test="product-page-valueprop">
      <Header 
        promptType={HeaderPromptTypes.VALUEPROP } 
        onInfoIconClick={handleInfoIconClick}
        isMobile={isMobile}>
        {customHeadertLabel}
      </Header>
      

      <ul className="value-bullets">
        {valueBullets.map(renderBullet)}
      </ul>

      <CollapsableList
        contracts={contracts}
        openState={open}
        selectedContractId={selectedContractId}
        toggleContract={toggleContract}
        setOpenState={setOpen}
      />
    </StyledValuePropPrompt>
  );
}